<template>
	<span class="error-feedback">
		<ul class="error-feedback__items">
			<li
				class="error-feedback__item"
				v-for="message in errorMessages"
				:key="message"
			>
				{{ message }}
			</li>
		</ul>
	</span>
</template>

<script>
export default {
	name: 'ErrorFeedback',
	props: {
		errorMessages: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
// UI/UX Note: review and tweek for a case with multiples messages

.error-feedback {
	display: flex;
	font-size: $default-font-size - 4;
	margin-top: $gutter-sm;

	&__items {
		min-width: calc(
			100% - (14px + #{$gutter-sm})
		); //icon container width + the right margin
		color: $ui-negative;
	}

	&__item {
		display: inline-block;
		vertical-align: middle;
		width: 100%;
	}

	> *:first-child {
		margin-right: $gutter-sm;
	}
}
</style>
